// Generated by DesignToCode

import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { SecondaryButton } from '../../ui/secondary-button/secondary-button';

@Component({
  selector: 'app-show-your-skills',
  standalone: true,
  imports: [CommonModule, SecondaryButton],
  templateUrl: './show-your-skills.html',
})
export class ShowYourSkills {
  public navigateToChallenge(): void {
    window.open(
      'https://medium.com/fromscratch-studio/skip-the-first-interview-show-us-your-skills-instead-ca02bc1af136',
      '_blank',
    );
  }
}
